import { render, staticRenderFns } from "./mooringTest-add-or-update.vue?vue&type=template&id=6c5189e5&scoped=true&"
import script from "./mooringTest-add-or-update.vue?vue&type=script&lang=js&"
export * from "./mooringTest-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./mooringTest-add-or-update.vue?vue&type=style&index=0&id=6c5189e5&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5189e5",
  null
  
)

export default component.exports